import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import TopTicker from "@/pages/home/components/TopTicker";
import HeroSection from "@/pages/home/components/HeroSection";
import EntryRail from "@/pages/home/components/EntryRail";
import LatestFeed from "@/pages/home/components/LatestFeed";
import TopicWall from "@/pages/home/components/TopicWall";
import MemberPerks from "@/pages/home/components/MemberPerks";
import CuratedCollections from "@/pages/home/components/CuratedCollections";
import CommentBuzz from "@/pages/home/components/CommentBuzz";
import PricingPlans from "@/pages/home/components/PricingPlans";
import FaqSection from "@/pages/home/components/FaqSection";

export default function Home() {
  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50">
      <TopTicker />
      <SiteHeader />
      <main className="flex-1">
        <HeroSection />
        <EntryRail />
        <LatestFeed />
        <TopicWall />
        <MemberPerks />
        <CuratedCollections />
        <CommentBuzz />
        <PricingPlans />
        <FaqSection />
      </main>
      <SiteFooter />
    </div>
  );
}